import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import store from "@/store";

moment.tz.setDefault("Europe/Copenhagen");
moment.locale("en");

// Safely register the moment plugin only once using a global flag
if (!window.__momentPluginRegistered && !Vue.prototype.$moment) {
  try {
    Vue.use(VueMoment, {
      moment,
    });
    window.__momentPluginRegistered = true;
  } catch (error) {
    console.warn("Vue Moment plugin failed to initialize:", error);
  }
}

export async function loadLangMoment(locale) {
  moment.locale(locale);
}

(async function () {
  await loadLangMoment(store.getters.locale);
})();

export default moment;
